export default __webpack_public_path__ + "static/media/animation-20.10051bc3.png";